import React, {
  memo,
  useState,
  useCallback,
  useEffect,
  useContext,
} from 'react';
// import { Card } from 'tea-component';
import DataTime from '@gp/components/DataTime';
import CommonSourceCard from '@gp/components/CommonSourceCard';
// import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import EllipsisTextBubble from '../../../EllipsisTextBubble';
// import ProjectItem from '@gp/components/ProjectItem';
// import Iconfont from '@gp/components/Iconfont';
// import GeneralModal from '@gp/components/GeneralModal';
// import SourceCard from './components/CommonSourceCard';
// import { useHistory } from 'umi';
// import { MENU_ID_MAP, SLASH_G_POP } from '@gp/constants/const';
import useData from './hooks/useData';
import {
  getValidDate,
  getFormatNumPlusOfUSD,
  getNumberOfDotUnit,
} from '@gp/utils/common';
// import { context as Context } from '@gp/components/Context';
import gameIcon from '@gp/assets/svg/gameInformation/game.svg';
// import dollarIcon from '@gp/assets/svg/gameInformation/dollar.svg';
// import groupIcon from '@gp/assets/svg/group.svg';
import defaultGameIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg';
import './index.scss';
import LogoList from '@/pages/globalpedia/pages/StudioDashboard/StudioOverall/components/LogoList';

const getValue = (data: string | number | undefined): string => {
  return data ? getNumberOfDotUnit(parseInt(String(data))) : '0';
};

interface KeyMetricsPropsType {
  loading: boolean;
  data: IStudioOverallProjectsLiveKeyMetricsData | undefined | null;
  sourceCardMsg: {
    loading: boolean;
    data: any;
  };
}

const DEFAULT_PROPS: KeyMetricsPropsType = {
  loading: false,
  data: null,
  sourceCardMsg: {
    loading: true,
    data: null,
  },
};

function KeyMetrics(props: KeyMetricsPropsType) {
  const { loading, data, sourceCardMsg } = props;

  // const history = useHistory();
  // const { filter, filterLoading }: StudioOverallProjectsLiveContextType =
  //   useContext(Context) || {};

  // const [visible, setVisible] = useState<boolean>(false);
  // const [visibleMore, setVisibleMore] = useState<boolean>(false);

  const {
    dataTime,
    projectCount,
    yearProjectCount,
    currentMonthGrossRevenue,
    ytmGrossRevenue,
    mau,
  } = useData({ loading, data, sourceCardMsg });

  const toDetails = useCallback((item: any, e: React.MouseEvent<Element, MouseEvent> | null, isJump = true) => {
    if (!item?.id) return '';
    const baseLink = window?.location?.origin;
    let url = '';
    switch (item?.entity_type?.toLowerCase()) {
      case 'mobile':
        url = `${baseLink}/v2/intelligence/topCharts/mobileGames/gamesDetails/${item?.id}/overview`;
        break;

      case 'pc':
        url = `${baseLink}/v2/intelligence/topCharts/pcGames/gamesDetails/${item?.id}/overview`;
        break;

      case 'console':
        url = `${baseLink}/v2/intelligence/topCharts/consoleGames/gamesDetails/${item?.id}/overview`;
        break;

      default:
        break;
    }
    if (isJump && url) {
      e?.preventDefault();
      e?.stopPropagation();
      window.open(url, '_blank');
    }

    return url;
  }, []);

  /* const handleResize = useCallback(() => {
    const projectsContainer = document.querySelector(
        '.dbg-studio-overall-projects-live-key-metrics-card-projects-container',
      ),
      projectsInnerBox = document.querySelector(
        '.dbg-studio-overall-projects-live-key-metrics-card-projects-box',
      );
    if (projectsContainer && projectsInnerBox) {
      setVisibleMore(
        projectsContainer?.clientWidth < projectsInnerBox?.clientWidth,
      );
    } else {
      setVisibleMore(false);
    }
  }, []);

  // 判断more按钮是否展示
  useEffect(() => {
    if (loading) return;
    handleResize();
  }, [loading]);

  // 添加resize监听，判断more按钮的显示
  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); */

  return (
    <>
      <div
        className="dbg-studio-overall-projects-live-key-metrics"
        // title="Key Metrics"
        // 这个时间产品说可以写死，取当年
        // operation={`Date: ${/* data?.date */(new Date())?.getFullYear() || '-'}`}
      >
        <div style={{ display: 'flex', alignItems: 'center' }} className="dbg-studio-overall-projects-live-key-metrics-title">
          Key Metrics
          <DataTime style={{ marginLeft: 6 }} dateType="Month" date={loading ? '' : dataTime} />
        </div>
        <div className="dbg-studio-overall-projects-live-key-metrics-card">
          <CommonSourceCard
            isLoading={loading}
            isNoData={!projectCount?.total}
            icon={<img src={gameIcon} alt="" />}
            title="Total Project counts: Live"
            value={getValue(projectCount?.total)}
            isPercentage={false}
            slot={
              <ul className="dbg-studio-overall-projects-live-key-metrics-card-category font14">
                <li className="dbg-studio-overall-projects-live-key-metrics-card-category-item">
                  <label>Amplifier:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(projectCount?.amplifier)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-live-key-metrics-card-category-item">
                  <label>Astra:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(projectCount?.astra)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-live-key-metrics-card-category-item">
                  <label>Fuel:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(projectCount?.fuel)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-live-key-metrics-card-category-item">
                  <label>Nexus:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(projectCount?.nexus)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-live-key-metrics-card-category-item">
                  <label>Saturn:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(projectCount?.saturn)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-live-key-metrics-card-category-item">
                  <label>Solar:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(projectCount?.solar)}
                  />
                </li>
                <li className="dbg-studio-overall-projects-live-key-metrics-card-category-item">
                  <label>Others:&nbsp;&nbsp;</label>
                  <EllipsisTextBubble
                    bubbleStyle={{ paddingRight: '10px' }}
                    text={getValue(projectCount?.others)}
                  />
                </li>
              </ul>
            }
          />
          <CommonSourceCard
            isLoading={loading}
            isNoData={!yearProjectCount?.total}
            icon={<img src={gameIcon} alt="" />}
            title="Newly launched last 12 months"
            value={getValue(yearProjectCount?.total)}
            isPercentage={false}
            slot={
              // <section className="dbg-studio-overall-projects-live-key-metrics-card-projects-container font14">
              //   <hgroup className="dbg-studio-overall-projects-live-key-metrics-card-projects-box">
              //     {Array.isArray(yearProjectCount?.list) &&
              //       yearProjectCount?.list?.map((t) => {
              //         return (
              //           <ProjectItem
              //             key={t?.id}
              //             src={t?.cover}
              //             title={t?.name || '-'}
              //             platformTranformSolt
              //             solt={
              //               <span
              //                 style={{
              //                   color: '#888',
              //                   display: 'block',
              //                   width: '100%',
              //                 }}
              //               >
              //                 {getValidDate(t?.release_time, 'YYYY-MM-DD')}
              //               </span>
              //             }
              //             data={t}
              //             toDetails={toDetails}
              //           />
              //         );
              //       })}
              //     {/* More按钮 */}
              //     {
              //       /* Array.isArray(yearProjectCount?.list) && (yearProjectCount?.list as [])?.length > 3 */ visibleMore && (
              //         <section className="dbg-studio-overall-projects-live-key-metrics-card-projects-btn-box">
              //           <span className="dbg-studio-overall-projects-live-key-metrics-card-projects-btn-shade"></span>
              //           <button
              //             className="dbg-studio-overall-projects-live-key-metrics-card-projects-btn"
              //             onClick={() => {
              //               setVisible(true);
              //             }}
              //           >
              //             <span>More</span>
              //             <Iconfont
              //               className="dbg-studio-overall-projects-live-key-metrics-card-projects-btn-arrow"
              //               type="title-arrow"
              //             />
              //           </button>
              //         </section>
              //       )
              //     }
              //   </hgroup>
              // </section>
              <LogoList
                title="Newly launched last 12 months"
                logos={yearProjectCount?.list || []}
                defaultLogo={defaultGameIcon}
                getBubbleMsg={(msg: any) => {
                  const date = msg?.date || '';

                  return (
                    <div className="dbg-studio-overall-logo-bubble">
                      <div>{msg?.name || '-'}</div>
                      <div className="dbg-studio-overall-logo-bubble-time">
                        {getValidDate(date, 'YYYY-MM-DD')}
                      </div>
                    </div>
                  );
                }}
                toDetails={toDetails}
                isModalShowItemDate
              />
            }
          />
        </div>
        {/* <hgroup className="dbg-studio-overall-projects-live-key-metrics-card" style={{marginTop: 20}}>
          <SourceCard
            isLoading={sourceCardMsg?.loading}
            isNoData={!currentMonthGrossRevenue?.value}
            icon={(<img src={dollarIcon} alt="" />)}
            title="Current Month Gross Revenue"
            value={getFormatNumPlusOfUSD(currentMonthGrossRevenue?.value)}
            percentV={currentMonthGrossRevenue?.percent}
            date={currentMonthGrossRevenue?.end_date}
          />
          <SourceCard
            isLoading={sourceCardMsg?.loading}
            isNoData={!ytmGrossRevenue?.value}
            icon={(<img src={dollarIcon} alt="" />)}
            title="YTM Gross Revenue"
            value={getFormatNumPlusOfUSD(ytmGrossRevenue?.value)}
            percentV={ytmGrossRevenue?.percent}
            date={ytmGrossRevenue?.start_date && ytmGrossRevenue?.end_date ? `${ytmGrossRevenue?.start_date} ~ ${ytmGrossRevenue?.end_date}` : ''}
          />
          <SourceCard
            isLoading={sourceCardMsg?.loading}
            isNoData={!mau?.value}
            icon={(<img src={groupIcon} alt="" />)}
            title="MAU"
            value={getFormatNumPlusOfUSD(mau?.value)}
            percentV={mau?.percent}
            date={mau?.end_date}
          />
        </hgroup> */}
      </div>
      {/* More弹窗 */}
      {/* <GeneralModal
        className="dbg-studio-overall-projects-live-key-metrics-card-projects-modal globalpedia-custom-scrollbar"
        visible={visible}
        title="Newly launched last 12 months"
        isFont14
        isFooter={false}
        // modalSize="xl"
        content={
          <hgroup className="dbg-studio-overall-projects-live-key-metrics-card-projects-modal-body">
            {Array.isArray(yearProjectCount?.list) &&
              yearProjectCount?.list?.map((t) => {
                return (
                  <ProjectItem
                    key={t?.id}
                    src={t?.cover}
                    title={t?.name || '-'}
                    platformTranformSolt
                    solt={
                      <span
                        style={{
                          color: '#888',
                          display: 'block',
                          width: '100%',
                        }}
                      >
                        {getValidDate(t?.release_time, 'YYYY-MM-DD')}
                      </span>
                    }
                    data={t}
                    toDetails={toDetails}
                  />
                );
              })}
          </hgroup>
        }
        onClose={() => {
          setVisible(false);
        }}
      /> */}
    </>
  );
}

KeyMetrics.defaultProps = DEFAULT_PROPS;

export default memo(KeyMetrics);
